import type { QuestionFormType } from "@/types/types";
import type { FC, ReactNode } from "react";
import ChecklistHeader from "./ChecklistHeader";
import ChecklistBody from "./ChecklistBody";

interface ChecklistTableProps {
  questionsForms: QuestionFormType[];
  pagination?: ReactNode;
}

const ChecklistTable: FC<ChecklistTableProps> = ({
  questionsForms,
  pagination,
}) => {
  return (
    <>
      <div className="border border-l border-ib-gray-lightest rounded-[8px]">
        <table className="w-full">
          <thead>
            <ChecklistHeader />
          </thead>
          <tbody>
            <ChecklistBody tableData={questionsForms} />
          </tbody>
        </table>
      </div>
      {pagination && <div className="mt-4">{pagination}</div>}
    </>
  );
};

export default ChecklistTable;
